<template>
  <div class="min-h-screen flex flex-col justify-between bg-[#181818]">
    <div class="flex-1 flex flex-col items-center justify-center mt-20">
      <div class="flex flex-col items-center w-full max-w-lg mx-4 relative">
        <!-- Cart SVG Illustration -->
        <div class="mb-2 flex flex-col items-center mt-2">
          <img
            src="@/assets/Order/empty-cart.png"
            alt="Empty Cart"
            class="w-96 h-96 object-contain mx-auto"
          />
        </div>
        <!-- Empty Cart Message -->
        <div class="text-center px-4 flex flex-col items-center">
          <div
            class="mb-3 text-white text-center"
            style="
              font-family: 'Great Vibes', cursive;
              font-size: 20px;
              font-weight: 400;
              letter-spacing: 6px;
              text-transform: capitalize;
            "
          >
            {{ t("emptyCart.ohNo") }}
          </div>
          <div
            class="mb-4 text-center text-[#F3D382]"
            style="
              font-family: 'DM Serif Display', serif;
              font-size: 40px;
              font-weight: 400;
              text-transform: capitalize;
            "
          >
            {{ t("emptyCart.title") }}
          </div>
          <div
            class="mb-8 text-center"
            style="
              color: #d9d9d9;
              font-family: 'DM Sans', sans-serif;
              font-size: 20px;
              font-weight: 400;
            "
          >
            {{ t("emptyCart.description") }}
          </div>
          <router-link to="/menu">
            <button
              class="mt-4 flex justify-center items-center w-[412px] h-[52px] px-3 py-4 gap-3 rounded-none border-2 border-[#F3D382] text-[#232323] font-bold tracking-wider transition bg-[#F3D382] hover:bg-[#e6ac29] hover:text-black"
              style="
                font-family: 'Cormorant SC', serif;
                font-size: 20px;
                font-weight: 700;
              "
            >
              {{ t("emptyCart.goToMenu") }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <SmartChatbot />
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import SmartChatbot from "@/components/SmartChatbot.vue";

const { t } = useI18n();
</script>
